import React from 'react';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';

const UserOrgDetails = ({ data }) => {

    return (
        <div className="row" style={{ border: "1px solid #aaa", borderRadius: "10px", margin: "10px" }}>
            <div className="col-md-12 col-12" style={{ borderBottom: "1px solid #ccc", marginBottom: "10px" }}>
                <div style={{ margin: "2px 20px", display: "flex", justifyContent: "space-between" }}>
                    {(data.Organization !== undefined && data.Organization.length > 0 && data.Organization[0].Logo !== "") &&
                        (<div style={{ borderRadius: "30px" }} className="cursor">
                            <img width="70" height="70" alt="Logo" src={`${baseURL}OrgLogo/${data.Organization !== undefined && data.Organization[0].Logo}`}></img>
                        </div>)}
<div className='text-uppercase mr-3' style={{ marginTop: "15px", fontWeight: "bold" }}>
                        <div style={{ fontSize: "0.75rem" }}><u>MFI Member ID</u></div>
                        <div>{data._id}</div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <FontAwesomeIcon style={{ fontSize: "20px" }} icon={faMobileAlt} />
                        <div><div style={{
                            padding: "0 10px", borderRadius: "10px",
                        }}><a style={{ textDecoration: "none" }} href={`tel:+91${data.Organization[0].Contact}`}>{data.Organization[0].Contact}</a></div>
                            <div style={{
                                padding: "0 10px", margin: "2px", borderRadius: "10px",
                            }}>{data.Organization[0].AlternateContact === 0 ? "" :
                                <a style={{ textDecoration: "none" }} href={`tel:+91${data.Organization[0].AlternateContact}`}>{data.Organization[0].AlternateContact}</a>}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].Name}
                        type="text"></input>
                    <span>Organization Name</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].GSTNumber}
                        type="text"></input>
                    <span>GST Number</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && (data.Organization[0].AddressLine1 +
                        " " + data.Organization[0].AddressLine2)}
                        type="text"></input>
                    <span>Address</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].Contact}
                        type="text"></input>
                    <span>Office Contact</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].City}
                        type="text"></input>
                    <span>City</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].State}
                        type="text"></input>
                    <span>State</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].Country}
                        type="text"></input>
                    <span>Country</span>
                </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
                <div className="text-field">
                    <input placeholder="" readOnly value={data.Organization !== undefined && data.Organization[0].PostalCode}
                        type="text"></input>
                    <span>Postal Code</span>
                </div>
            </div>

        </div>
    );
};

export default UserOrgDetails;
